export default theme => ({
  wrapper: {
    textAlign: "center",
    verticalAlign: "middle",
  },
  largeIcon: {
    "& svg": {
      fontSize: 80,
    },
  },
});
